export default {
  listTransaksi: (state) => state.listTransaksi,
  totalData: (state) => state.totalData,
  dataDetail: (state) => state.detailTransaksi,
  exporting: (state) => state.exporting,
  multipleExport: (state) => state.multipleExport,
  minExport: (state) => state.minimizedExport,
  exportData: (state) => state.exportData,
  exportDataLength: (state) => state.exportDataLength,
  expProgress: (state) => state.exportProgress,
  notaTransaksi: (state) => state.notaTransaksi,
  isFecthing: (state) => state.fetching,
  pagination: (state) => state.pagination,
  search: (state) => state.search,
  onFilter: (state) => state.onFilter,
  isLoadMore: (state) => state.loadMore,
  getResponse: (state) => state.response,
  getSorting: (state) => state.sorting,
  scrollPosition: (state) => state.scrollPosition,
  toastSuccess: (state) => state.useToastSuccess,
};
